import React from 'react';
import DataResource from '../../../../common/v4/DataResource'
import Panel from '../../../../common/layout/Panel'
import UploadModal from './../../../../common/UploadModal'


export default class extends React.Component {
    render () {
        const data = {
            url: `/admin/products/voice/rates`,
            data: {
                data: [],
                metadata: []
            },
            onclick: 'link',
            link: '/products/voice/rates/{id}',
            userFilterSimple: true,
            userfilter:
                [
                    {
                        source: 'name',
                        label: 'Name',
                        type: 'text'
                    }
                ],
            metadata:
                [
                    {
                        'label': 'id',
                        'source': 'id',
                        'type': 'primary',
                        'editable': false,
                        'visible': false
                    },
                    {
                        'label': 'Name',
                        'source': 'name',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': 'New Rate table...'
                    },
                    {
                        'label': 'Description',
                        'source': 'description',
                        'type': 'text',
                        'editable': true,
                        'visible': true
                    },
                    {
                        'label': 'Delete',
                        'source': 'id',
                        'type': 'delete',
                        'visible': true
                    }
                ]
        }
        return (
            <Panel title = "Voice Rate Tables" options = {<Upload {...this.props}/>}>
                <DataResource
                    addButtonText = "Create Voice Rate Table"  
                    addButtonLink = "/products/voice/rates/create"
                    data = {data}
                    {...this.props} 
                />
            </Panel>
        )
    }
}

class Upload extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            modalIsOpen: false,
            refetch: 0
        }
    }
    onUploadRequest() {
        this.setState({ modalIsOpen: true})
    }
    onHide() {
        this.setState({ modalIsOpen: false})
    }
    onUploadSuccess() {
        this.setState({
            refetch: Math.random(),
            modalIsOpen: false
        });

    }
    render() {
        return(
            <div>
                <UploadModal
                    modalIsOpen = {this.state.modalIsOpen}
                    onHide = {this.onHide.bind(this)}
                    onUploadSuccess = { this.onUploadSuccess.bind(this) }
                    modalTitle = "Upload Voice Rate Table"
                    url_upload = "/admin/products/voice/rates/upload"
                    url_confirm = "/admin/products/voice/rates/confirm"
                    childProps = {this.props.childProps }
                />
                <button onClick={this.onUploadRequest.bind(this)} className="btn btn-upload">Upload Voice Rate Table</button>
            </div>)
    }
}
